import {
  CREATE_GOAL,
  LOAD_VIEW_GOALS_PAGE,
  GET_USER_GOALS,
  GET_GOAL_PROGRESS,
  STOP_GOAL,
} from './constants'
import { selectMapmyVersion } from 'services/bootup/selectors'
import { constructCreateGoalPayload } from './helpers'

export function createGoal (goal, userId, convertedTarget) {
  return (dispatch, getState, { mapmy }) => {
    const mapmyVersion = selectMapmyVersion(getState())
    const payload = constructCreateGoalPayload(goal, userId, convertedTarget, mapmyVersion)

    return dispatch({
      type: CREATE_GOAL,
      payload: mapmy.createGoal(payload),
      meta: {
        globalErrorNotification: true,
      },
    })
  }
}

export function getUserGoals (userId) {
  const params = {
    user: userId,
    datetime_overlaps: (new Date()).toISOString(),
  }

  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: GET_USER_GOALS,
      payload: mapmy.getUserGoals(params),
      meta: {
        globalErrorNotification: true,
      },
    })
  }
}

export function getGoalProgress (goalId) {
  const params = {
    user_goal: goalId,
    datetime_overlaps: (new Date()).toISOString(),
  }

  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: GET_GOAL_PROGRESS,
      payload: mapmy.getGoalProgress(params),
      meta: {
        globalErrorNotification: true,
      },
    })
  }
}

export function loadViewGoalsPage (userId) {
  return (dispatch) => {
    const promise = Promise.resolve()
      .then(() => {
        return dispatch(getUserGoals(userId))
      })
      .then((goals) => {
        const goalResults = goals.value.data._embedded.user_goals.map((goal) => {
          const goalId = goal._links.self[0].id
          return dispatch(getGoalProgress(goalId))
        })

        return Promise.all(goalResults)
      })

    return dispatch({
      type: LOAD_VIEW_GOALS_PAGE,
      payload: promise,
      meta: {
        globalErrorNotification: true,
      },
    })
  }
}

export function stopGoal (goalId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: STOP_GOAL,
      payload: mapmy.stopUserGoal(goalId),
      meta: {
        globalErrorNotification: true,
        deletedGoal: goalId,
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/goals/actions.js